/**
 * Catalogo in italiano per la funzione `community` (forum, discussioni, Hall of
 * Legends). Le chiavi rispecchiano le chiamate `t('community.*')` in
 * packages/@gamecodex/world-ui/src/features/community.
 */
export const communityIt = {
  // CommunityPage
  'community.page.seoTitle': 'Community',
  'community.page.seoDescription':
    'Unisciti alla community di Grymwyrd: forum, teorie sul lore, strumenti da Dungeon Master, homebrew e la Hall of Legends.',
  'community.page.eyebrow': 'Il Raduno del Buio',
  'community.page.title': 'Community',
  'community.page.intro':
    'Scambia tattica, sviluppa teorie, condividi homebrew e ascendi verso il canone. Ogni post che scrivi ti guadagna monete e reputazione nel crepuscolo eterno.',
  'community.page.loading': 'Radunando i fedeli…',
  'community.page.forumCategories': 'Categorie del Forum',
  'community.page.categoryStats': '{threads} discussioni · {posts} messaggi',
  'community.page.recentActivity': 'Attività Recente',
  'community.page.liveFeed': 'feed in diretta',
  'community.page.recentEmpty':
    'I forum sono silenziosi questa notte. Avvia una discussione per svegliare i morti.',
  'community.page.hallOfLegends': 'Hall of Legends',
  'community.page.hallBlurb': 'I più grandi contributori e i personaggi che hanno plasmato il canone.',
  'community.page.enterTheHall': 'Entra nella Hall',
  'community.page.playerSpotlights': 'In Primo Piano',
  'community.page.summoningLegends': 'Evocando le leggende…',
  'community.page.sampleNotice': 'Visualizzazione di contenuti di esempio mentre i forum viventi si risvegliano.',

  // FlagButton
  'community.flag.errorQueued':
    'Non siamo riusciti a contattare i moderatori in questo momento, ma la tua segnalazione è stata messa in coda.',
  'community.flag.ariaLabel': 'Segnala questo messaggio per la moderazione',
  'community.flag.label': 'Segnala',
  'community.flag.modalTitle': 'Rapporto ai Guardiani',
  'community.flag.successDelivered':
    'Il tuo rapporto è stato consegnato ai moderatori. I Guardiani ti ringraziano.',
  'community.flag.close': 'Chiudi',
  'community.flag.signInNotice':
    'Puoi comunque descrivere il problema, ma devi aver effettuato l\'accesso perché la segnalazione raggiunga i moderatori.',
  'community.flag.whyFlagging': 'Perché stai segnalando questo?',
  'community.flag.reason.spamOrAdvertising': 'Spam o pubblicità',
  'community.flag.reason.harassmentOrAbuse': 'Molestie o abuso',
  'community.flag.reason.spoilersWithoutWarning': 'Spoiler senza avvertimento',
  'community.flag.reason.offTopic': 'Fuori tema',
  'community.flag.reason.otherDescribeBelow': 'Altro (descrivi sotto)',
  'community.flag.describeIssue': 'Descrivi il problema',
  'community.flag.detailPlaceholder': 'Racconta ai Guardiani cosa c\'è che non va…',
  'community.flag.cancel': 'Annulla',
  'community.flag.reporting': 'Invio della segnalazione…',
  'community.flag.submitReport': 'Invia segnalazione',

  // ForumCategoryPage
  'community.category.seoTitle': '{name} — Forum',
  'community.category.seoDescription': 'Discussioni nel forum {name} su Grymwyrd.',
  'community.category.breadcrumb': 'Community',
  'community.category.entityTiedPrefix': 'Bacheca legata all\'entità · le discussioni possono collegarsi a',
  'community.category.encyclopediaEntries': 'voci dell\'enciclopedia',
  'community.category.sampleNotice': 'Visualizzazione di discussioni di esempio mentre il forum vivente si risveglia.',

  // HallOfLegendsPage
  'community.legends.seoTitle': 'Hall of Legends',
  'community.legends.seoDescription':
    'I più grandi contributori a Grymwyrd e i personaggi che hanno plasmato il canone.',
  'community.legends.breadcrumb': 'Community',
  'community.legends.title': 'Hall of Legends',
  'community.legends.intro':
    'Qui stanno gli architetti del crepuscolo eterno — i contributori le cui parole divennero legge, e i personaggi così amati da essere incisi nel canone.',
  'community.legends.loading': 'Accendendo le candele…',
  'community.legends.topContributors': 'Contributori Principali',
  'community.legends.noContributors':
    'Nessuna leggenda si è ancora levata. Pubblica, teorizza e crea per reclamare il tuo posto.',
  'community.legends.canonizedCharacters': 'Personaggi nel Canone',
  'community.legends.noCharacters':
    'Nessun personaggio è stato ancora inserito nel canone. Il bestiario aspetta il prossimo orrore.',
  'community.legends.sampleNotice': 'Visualizzazione di leggende di esempio mentre la hall vivente viene consacrata.',

  // NestedReplies
  'community.replies.replyBy': 'Risposta di {author}',
  'community.replies.reply': 'Rispondi',
  'community.replies.replyToPlaceholder': 'Rispondi a {author}…',
  'community.replies.unlike': 'Rimuovi il "mi piace" da questo messaggio',
  'community.replies.like': 'Mi piace questo messaggio',

  // PlayerSpotlight
  'community.spotlight.rep': '{rep} reputazione',
  'community.spotlight.viewInEncyclopedia': 'Visualizza {name} nell\'enciclopedia',

  // PostComposer
  'community.composer.placeholder': 'Aggiungi la tua voce al buio…',
  'community.composer.signInPrompt': 'Accedi per unirti alla discussione e guadagna monete per le tue parole.',
  'community.composer.signInToReply': 'Accedi per rispondere',
  'community.composer.youFallback': 'Tu',
  'community.composer.saveError':
    'La tua risposta non può ancora essere salvata sul server — è mostrata solo localmente.',
  'community.composer.writeReply': 'Scrivi una risposta',
  'community.composer.writePost': 'Scrivi un messaggio',
  'community.composer.replyText': 'Testo della risposta',
  'community.composer.postText': 'Testo del messaggio',
  'community.composer.posting': 'Invio…',
  'community.composer.postReply': 'Pubblica risposta',
  'community.composer.post': 'Pubblica',
  'community.composer.cancel': 'Annulla',
  'community.composer.coinsPerPost': '+{count} monete per messaggio',
  'community.composer.coinsEarned': '+{count} monete guadagnate per il tuo messaggio!',

  // ThreadItem
  'community.thread.pinned': 'Discussione fissata',
  'community.thread.byPrefix': 'di',
  'community.thread.repliesTitle': '{count} risposte',
  'community.thread.likesTitle': '{count} mi piace',
  'community.thread.viewsTitle': '{count} visualizzazioni',
  'community.thread.entityEntry': 'voce {type}',

  // ThreadList
  'community.threadList.empty':
    'Nessuna discussione ha animato questo spazio. Sii il primo a rompere il silenzio.',

  // ThreadPage
  'community.threadPage.loading': 'Sigillando il filo…',
  'community.threadPage.seoDescription': 'Una discussione nei forum della community di Grymwyrd.',
  'community.threadPage.replyCount': '{count} risposte',
  'community.threadPage.opened': 'aperto {time}',
  'community.threadPage.entityEntry': 'voce {type}',
  'community.threadPage.sampleNotice': 'Visualizzazione di discussione di esempio mentre il forum vivente si risveglia.',
  'community.threadPage.openingPostBy': 'Messaggio iniziale di {author}',
  'community.threadPage.repliesHeading': 'Risposte',
  'community.threadPage.noReplies': 'Nessuna risposta ancora. Sii il primo a rispondere alla chiamata.',
  'community.threadPage.addYourReply': 'Aggiungi la tua risposta',
} as const
